import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import logo from './images/logo.png'; // Import the logo
import Chat from './chat'; // Import Chat component

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          {/* Main Page Route */}
          <Route
            path="/"
            element={
              <>
                <div className="text-container">
                  <h1>Feel It !</h1> {/* Added name before the paragraph */}
                  <p className="intro-text">
                    "Hey friend, is your heart feeling heavy? Let music be that comforting hug you need, soothing your soul when words just can't reach. Let it heal the wounds that go deep, lifting your spirit and bringing you peace, just when you need it most."
                  </p>
                </div>
                <div className="left">
                  <img src={logo} alt="Logo" className="logo" />
                  <Link to="/chat">
                    <button className="talk-btn">Let's Talk !</button>
                  </Link>
                </div>
              </>
            }
          />
          
          {/* Chat Page Route */}
          <Route path="/chat" element={<Chat />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
